import { useEffect, useMemo } from 'react';
import { io } from 'socket.io-client';
import config from '../../config'

const useChatSocket = token => {
    const socket = useMemo(() => {
        const url = config.chatUrl;
        return io(url, { autoConnect: false });
    }, []);

    useEffect(() => {
        if (!token) {
            return;
        }

        socket.auth = { token };
        socket.connect();

        return () => {
            socket.removeAllListeners();
            socket.disconnect();
        };
    }, [socket, token]);

    return socket;
};

export { useChatSocket };
